<!-- eslint-disable max-len -->
<template>
    <div class="search-container">
        <div class="input-wrapper">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
            >
                <!-- eslint-disable -->
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.11104 0.264893C2.92012 0.264893 0.333374 2.85164 0.333374 6.04256C0.333374 9.23348 2.92012 11.8202 6.11104 11.8202C7.46629 11.8202 8.71255 11.3536 9.69794 10.5723L12.0843 12.9586L13.0271 12.0158L10.6407 9.62946C11.4221 8.64407 11.8887 7.39781 11.8887 6.04256C11.8887 2.85164 9.30196 0.264893 6.11104 0.264893ZM6.11104 1.59823C8.56558 1.59823 10.5554 3.58802 10.5554 6.04256C10.5554 8.4971 8.56558 10.4869 6.11104 10.4869C3.6565 10.4869 1.66671 8.4971 1.66671 6.04256C1.66671 3.58802 3.6565 1.59823 6.11104 1.59823Z"
                    fill="#666666"
                />
            </svg>
            <input
                class="spc-form-input s-input"
                type="text"
                v-model="searchValue"
                placeholder="输入快手号/用户ID/昵称"
                @input="handleSearch"
            />
            <svg
                v-show="searchValue"
                @click="clearInput"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
            >
                <!-- eslint-disable -->
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.4749 4.11089L11.8892 5.5252L9.414 8L11.8891 10.4749L10.4749 11.8891L8 9.414L5.5252 11.8892L4.11089 10.4749L6.586 7.999L4.11083 5.52521L5.52521 4.11083L8 6.586L10.4749 4.11089Z"
                    fill="var(--service-button, #000)"
                    fill-opacity="0.2"
                />
            </svg>
        </div>
        <div class="history-wrapper" v-show="!searchValue && renderTags.length">
            <div class="top">
                <div class="history">
                    历史搜索
                </div>
                <div class="delete" @click="deleteHistory">
                </div>
            </div>
            <!-- <div class="tag-list">
                <div
                    class="tag"
                    v-for="tag in renderTags"
                    :key="tag"
                    @click="clickTag(tag)"
                >
                    {{ tag }}
                </div>
            </div> -->
            <tags ref="historyTags" :tag-list="renderTags" @clickTag="clickTag"/>
        </div>
        <csc-list
            v-show="searchValue"
            :list="searchResult"
            :showLoading="showLoading"
            class="search-user-list"
        >
            <csc-base-user-card
                v-for="(item, index) in searchResult"
                :key="index"
                :userCardInfo="item"
                :isSelected="false"
                class="search-card"
                @choose-click="onUserItemClick"
            ></csc-base-user-card>
            <div
                v-if="hasMore"
                v-io
                class="list-loading"
                @exposed="getMoreData"
            ></div>
        </csc-list>
        <no-result-btn @on-no-result-click="onNoResult" v-if="searchValue"></no-result-btn>
        <sp-dialog
            transferDom
            v-model="showHistoryDialog"
            class="mask-delete"
            :content="'搜索记录删除后将无法恢复，确认删除全部搜索?'"
            :btns="btn"
        ></sp-dialog>
    </div>
</template>
<script>
import { Dialog } from '@ks/sharp-ui';
import CscDesign from '@ks-csc/mobile-design';
import { debounce } from 'lodash';
import { fetchUser, getHistory, setHistory } from './data-util';
import Tags from './tags.vue';
import NoResultBtn from '../component-base/common/no-result-btn';

const { CscBaseUserCard, CscList } = CscDesign;
export default {
    name: 'search-page',
    components: {
        CscBaseUserCard,
        CscList,
        SpDialog: Dialog,
        Tags,
        NoResultBtn,
    },
    data() {
        return {
            searchValue: '',
            showLoading: false,
            hasMore: false,
            showHistoryDialog: false,
            page: 0,
            searchResult: [],
            tagList: [],
            btn: [
                {
                    text: '取消',
                    handler: () => {
                        this.showHistoryDialog = false;
                    },
                },
                {
                    text: '确定',
                    handler: () => {
                        this.tagList = [];
                        setHistory(this.tagList);
                        this.showHistoryDialog = false;
                    },
                },
            ],
        };
    },
    watch: {
        searchValue(val) {
            if (!val) {
                this.updateHistoryTags();
            }
        },
    },
    computed: {
        renderTags() {
            return Array.from(new Set(this.tagList));
        },
    },
    async mounted() {
        const history = await getHistory();
        this.tagList = history.slice(0, 20) || [];
        // eslint-disable-next-line max-len
        // this.tagList = [{ id: 33, value: '二十' }, { id: 32, value: '十九' }, { id: 31, value: '十八' }, { id: 30, value: '十七' }, { id: 29, value: '十六' }, { id: 28, value: '十五' }, { id: 27, value: '十四' }, { id: 26, value: '十三' }, { id: 25, value: '十二' }, { id: 24, value: '十一' }, { id: 23, value: '是' }, { id: 22, value: '测试' }, { id: 21, value: '二十一' }, { id: 8, value: '你说你什么意思、测试' }, { id: 7, value: '我在' }, { id: 6, value: '测试了一个多分钟还' }, { id: 5, value: '测试方法与使用有关事项通知如下意见如下' }, { id: 4, value: '作品赏析。作品的特点与作品信息' }, { id: 3, value: '工业园区内心充满阳光味道不错？你说了你没办' }];
        // this.tagList = this.tagList.map(item => item.value);
        // eslint-disable-next-line max-len
        // this.tagList = [...history, ...history, ...history, '文字文字', '文字文字文字文字文字文字', '文字文字文字文字文字文字', '文字文字文字文字文字文字文字', '文字文字文字文字', '文字文字文字文'].slice(0, 20);
    },
    methods: {
        onNoResult() {
            this.$emit('on-no-result-click');
        },
        updateHistoryTags() {
            this.$refs.historyTags && this.$refs.historyTags.reRender();
        },
        clearInput() {
            this.searchValue = '';
        },
        async onUserItemClick(item) {
            this.tagList.unshift(this.searchValue);
            this.tagList = this.tagList.slice(0, 20);
            setHistory(this.tagList);
            this.$emit('userSelect', item);
        },
        deleteHistory() {
            this.showHistoryDialog = true;
        },
        handleSearch: debounce(async function () {
            this.showLoading = true;
            this.page = 0;
            this.searchResult = [];
            await this.fetchUser();
            this.showLoading = false;
        }, 500),
        async fetchUser() {
            const res = await fetchUser({
                keyword: this.searchValue,
                page: this.page,
            });
            const { hasMore, itemList } = res.data;
            this.hasMore = hasMore;
            this.searchResult = [...this.searchResult, ...itemList];

            // const a = [];
            // for (let i = 0; i < 20; i++) {
            //     a.push(this.searchResult[0]);
            // }
            // this.searchResult = a;

            this.page += 1;
        },
        clickTag(item) {
            this.searchValue = item;
            this.handleSearch();
        },
        getMoreData() {
            // console.log('[zy] ', 'getMoreData');
            this.fetchUser();
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.search-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
}
.mask-delete {
    z-index: 1001;
}
.list-loading {
    width: 0.3rem;
    height: 0.3rem;
    margin: 0 auto;
    background: var(--csc-collect-list-loading) no-repeat;
    background-size: contain;
}
.live-item {
  margin: 0 0.04rem 0.2rem;
  width: 1.84rem;
}
.input-wrapper {
    padding: 10px 12px;
    margin: 12px 19px;
    height: 20px;
    min-height: 20px;
    max-height: 20px;
    border-radius: 20px;
    background: var(--button-bg, #fff);
    display: flex;
    align-items: center;
    color: var(--font-common,#222);
    .spc-form-input {
      color: var(--font-common,#222);
      font-size: .14rem;
    }
  .s-input {
    margin-left: 6px;
    line-height: 20px;
    width: 100%;
  }
}
.history-wrapper {
  margin: 0 .19rem;
  margin-top: 12px;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .history {
      color: var(--service-button, #000);
      font-size: 15px;
      font-weight: bold;
      line-height: 21px;
    }
    .delete {
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/images/delete-gray.svg');
    }
  }
  .tag-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 12px 0;
    .tag + .tag {
      margin-right: 8px;
      margin-top: 8px;
    }
    .tag {
      color: var(--font-common, #222);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      max-width: 134px;
      white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    //   display: inline-flex;
      padding: 6px 12px;
    //   justify-content: center;
    //   align-items: center;
    //   gap: 10px;
      border-radius: 8px;
      background: var(--button-bg, #fff);
      &:first-of-type {
        margin-right: 8px;
        margin-top: 8px;
      }
    }
  }
}
.search-card {
    margin: 12px 19px;
    background-color: var(--button-bg, #fff);
    &:first-of-type {
        margin-top: 0;
    }
    /deep/ .csc-image img {
        object-fit: cover;
        position: static;
        transform: none;
        border-radius: 50%;
        &::after {
            display: none;
        }
    }
}
.search-user-list {
    flex: 1;
    overflow: auto;
  /deep/ .no-data {
    margin-top: 172px;
  }
  /deep/ .k-loading {
    margin-top: 172px;
  }
}
</style>
